import { TSelectData } from '@components/formFields/select/types'
import { t } from '@lingui/core/macro'

export interface IState {
  selected: {
    templateId: string | null
    columnId: number | string | null
  }
  templateOptions: TSelectData[]
  columnOptions: TSelectData[]
}

export const ACTION_TYPE = {
  setSelections: 'setSelections',
  setTemplateSelection: 'setTemplateSelection',
  setColumnSelection: 'setColumnSelection',
  clearSelected: 'clearSelected',
  setTemplateOptions: 'setTemplateOptions',
  setColumnOptions: 'setColumnOptions',
} as const

type Action =
  | { type: typeof ACTION_TYPE.setSelections; payload: IState['selected'] }
  | { type: typeof ACTION_TYPE.setTemplateSelection; payload: IState['selected']['templateId'] }
  | { type: typeof ACTION_TYPE.clearSelected }
  | { type: typeof ACTION_TYPE.setColumnSelection; payload: IState['selected']['columnId'] }
  | { type: typeof ACTION_TYPE.setTemplateOptions; payload: IState['templateOptions'] }
  | { type: typeof ACTION_TYPE.setColumnOptions; payload: IState['columnOptions'] }
  | { type: string; payload: any }

export function reducer(state: IState, action: Action): IState {
  const actionType = action.type
  switch (action.type) {
    case ACTION_TYPE.setSelections: {
      const { templateId, columnId } = action.payload
      return {
        ...state,
        selected: {
          templateId,
          columnId,
        },
      }
    }
    case ACTION_TYPE.setTemplateSelection:
      return {
        ...state,
        selected: {
          ...state.selected,
          templateId: action.payload,
        },
      }
    case ACTION_TYPE.setColumnSelection:
      return {
        ...state,
        selected: {
          ...state.selected,
          columnId: action.payload,
        },
      }
    case ACTION_TYPE.clearSelected: {
      return {
        ...state,
        selected: {
          templateId: null,
          columnId: null,
        },
      }
    }
    case ACTION_TYPE.setTemplateOptions: {
      return {
        ...state,
        templateOptions: action.payload,
      }
    }
    case ACTION_TYPE.setColumnOptions: {
      return {
        ...state,
        columnOptions: action.payload,
      }
    }
    default:
      throw Error(t`The action.type ${actionType} does not exist in the reducer.`)
  }
}
